import {api} from '../api';
import type {Ticket, Knowledge, GmailStatus, AIModelSettings} from '../types';
import type {WorkspaceSnapshot} from '../workspace/types';

export async function loadWorkspace(): Promise<WorkspaceSnapshot> {
  const controller = new AbortController();
  try {
    const options = {signal: controller.signal};
    const modelRequest = api<AIModelSettings>('/ai/models', options).catch(() => null);
    const [tickets, docs, gmail, aiSettings] = await Promise.all([
      api<Ticket[]>('/tickets', options), api<Knowledge[]>('/knowledge', options),
      api<GmailStatus>('/gmail/status', options), modelRequest,
    ]);
    return {tickets, docs, gmail, aiSettings};
  } catch (failure: unknown) {
    controller.abort();
    throw failure;
  }
}

export async function loadInbox(): Promise<{tickets: Ticket[]; gmail: GmailStatus}> {
  const [tickets, gmail] = await Promise.all([api<Ticket[]>('/tickets'), api<GmailStatus>('/gmail/status')]);
  return {tickets, gmail};
}